export default __webpack_public_path__ + "static/media/nurse.23aa9043.png";